import { DialogPassThroughMethodOptions, DialogPassThroughOptions } from "primereact/dialog";
import { classNames } from "primereact/utils";

export const dialog: DialogPassThroughOptions = {
  root: ({ state }: DialogPassThroughMethodOptions) => ({
    className: classNames(
      "rounded-lg shadow-lg border-0",
      "max-h-[90%] transform scale-100",
      "flex flex-col",
      "m-0 w-[50vw]",
      "dark:border dark:border-blue-900/40",
      {
        "transition-none transform-none !w-screen !h-screen !max-h-full !top-0 !left-0":
          state.maximized,
      },
    ),
  }),
  header: {
    className: classNames(
      "flex items-center justify-between shrink-0",
      "bg-white text-gray-800 border-t-0  rounded-tl-lg rounded-tr-lg px-6 py-4",
      "dark:bg-gray-900  dark:text-white/80",
    ),
  },
  headerTitle: () => "font-bold text-lg",
  headerIcons: () => "flex items-center",
  closeButton: {
    className: classNames(
      "flex items-center justify-center overflow-hidden relative",
      "w-6 h-6 text-gray-500 border-0 bg-transparent rounded-full transition duration-200 ease-in-out mr-2 last:mr-0",
      "hover:text-gray-700 hover:border-transparent hover:bg-gray-200",
    ),
  },
  closeButtonIcon: () => "w-4 h-4 inline-block",
  content: ({ props, state }: DialogPassThroughMethodOptions) => ({
    className: classNames(
      "overflow-y-auto",
      "bg-white text-gray-700 px-6 pb-8 pt-0",
      { "rounded-bl-lg rounded-br-lg": !props.footer },
      "dark:bg-gray-900  dark:text-white/80 ",
      {
        grow: state.maximized,
      },
    ),
  }),
  footer: {
    className: classNames(
      "flex gap-2 shrink-0 justify-end align-center",
      "border-t-0 bg-white text-gray-700 px-6 py-4 text-right rounded-b-lg",
      "dark:bg-gray-900 dark:text-white/80",
    ),
  },
  mask: ({ state }: DialogPassThroughMethodOptions) => ({
    className: classNames("transition duration-200", { "bg-black/40": state.containerVisible }),
  }),
};
